import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Box
} from '@mui/material';
import {
  Add as AddIcon,
  Lightbulb as LightbulbIcon,
  CreditCard as CreditCardIcon
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useSimulation } from '../../contexts/SimulationContext';
import { useCreateWithTrialCheck } from '../../hooks/useCreateWithTrialCheck';
import TrialStatusModal from '../TrialStatusModal';

export const CtaSection: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { dispatch } = useSimulation();
  const isAdmin = user?.role === 'ADMIN';
  
  const {
    handleCreateAction,
    isTrialStatusModalOpen,
    closeTrialStatusModal,
    isAdmin: trialAdmin
  } = useCreateWithTrialCheck();

  return (
    <>
    <Box sx={{ mb: 3, display: 'flex', justifyContent: { xs: 'stretch', md: 'stretch-end' } }}>
      <Card 
        elevation={0} 
        sx={{ 
          borderRadius: 3, 
          border: '1px solid', 
          borderColor: 'divider', 
          width: { xs: '100%', md: 'auto' },
          minWidth: { md: '400px' }
        }}
      >
        <CardContent>
          {/* <Typography variant="h6" gutterBottom>
            Quick Actions
          </Typography> */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            sx={{ mt: 2 }}
          >
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleCreateAction(() => {
              dispatch({ type: 'RESET_FORM' });
              navigate('/simulations/create');
            })}
            sx={{ 
              textTransform: 'none',
              width: { xs: '100%', sm: 'auto' }
            }}
          >
            New Simulation
          </Button>
          <Button
            variant="contained"
            startIcon={<LightbulbIcon />}
            onClick={() => handleCreateAction(() => navigate('/ideas/create'))}
            color="secondary"
            sx={{ 
              textTransform: 'none',
              width: { xs: '100%', sm: 'auto' }
            }}
          >
            New Idea
          </Button>
          {isAdmin && (
            <Button
              variant="outlined"
              startIcon={<CreditCardIcon />}
              onClick={() => navigate('/settings?section=billing')}
              sx={{ 
                textTransform: 'none',
                width: { xs: '100%', sm: 'auto' }
              }}
            >
              Manage Subscription
            </Button>
          )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
    
    <TrialStatusModal 
      isOpen={isTrialStatusModalOpen} 
      onClose={closeTrialStatusModal} 
      isAdmin={trialAdmin}
      status="expired"
    />
    </>
  );
};